import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilter from "./components/ReportFilter";

const SoldUnitReport = () => {
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);
  const [totalSold, setTotalSold] = useState(0);

  const fetchReport = async () => {
    const res = await axios.get("/api/reports/sold-units", {
      params: filters,
    });
    console.log("sold_Units...Filters", res.data.data,filters);
    setData(res.data.data);
    setTotalSold(res.data.total_sold);
  };

const downloadCSV = async () => {
  const res = await axios.get("/api/reports/sold-units/csv", {
    params: filters,
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "sold-unit-report.csv");
  document.body.appendChild(link);
  link.click();
};

const downloadPDF = async () => {
  const res = await axios.get("/api/reports/sold-units/pdf", {
    params: filters,
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "sold-unit-report.pdf");
  document.body.appendChild(link);
  link.click();
};

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">Sold Unit Report</h4>

      <ReportFilter
        filters={filters}
        setFilters={setFilters}
        onSearch={fetchReport}
      />

      <div className="card shadow-sm">
        <div className="card-body">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Type</th>
                <th>Area</th>
                <th>Price</th>
                <th>Status</th>
                <th>Total Sold</th>
                <th>Unit Number</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    No pending data
                  </td>
                </tr>
              ) : (
                
  data.map((row, index) => (
    <tr key={index}>
      <td>{row.type?.name}</td>
      <td>{row.property?.location?.area}</td>
      <td>{row.price}</td>
      <td>{row.status?.status_type}</td>
      <td>{totalSold}</td>
      <td>{row.unit_number}</td>
    </tr>
  )))}
</tbody>
              
            
          </table>

          <div className="text-end">
            <button className="btn btn-danger" onClick={downloadPDF}>
               PDF Download
            </button>
            <button className="btn btn-secondary ms-2" onClick={downloadCSV}>
               CSV Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoldUnitReport;
